"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ThemeProvider = require("../../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("../style"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var Anchor = _react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: classes.Anchor
  }, children);
});

Anchor.displayName = 'ContentBox.Anchor';
var _default = Anchor;
exports["default"] = _default;
//# sourceMappingURL=Anchor.js.map